import React, { Fragment } from 'react'
import { fontSize, spacer } from 'stylist'
import styled from '@emotion/styled'

const Title = styled.div`
  ${fontSize('xs')};
  margin-bottom: ${spacer(1)};
`

const Indented = styled.div`
  ${fontSize('xxs')};
  margin-left: ${spacer(2)};
`

const AndMore = styled(Indented)`
  font-style: italic;
`

/**
 * Displays a preview of the qualification
 * @param {String} title
 * @param {Array|React.Node} contents
 * @param {Number} maxContents
 */
const QualPreview = ({ title, contents, locale, maxContents = 4 }) => (
  <Fragment>
    <Title>{title}</Title>
    {Array.isArray(contents) ? (
      <Fragment>
        {contents.slice(0, maxContents).map((line, idx) => (
          <Indented key={idx}>{line}</Indented>
        ))}
        {contents.length > maxContents ? (
          locale === 'en_US' ? (
            <AndMore>...and more</AndMore>
          ) : (
            <AndMore>...</AndMore>
          )
        ) : null}
      </Fragment>
    ) : (
      contents
    )}
  </Fragment>
)

export default QualPreview



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QualPreview.js